export interface NavLinkItem {
  label: string;
  href: string;
}

export interface HeroLineItem {
  id: string;
  name: string;
  latency: string;
  status: string;
  tone: 'good' | 'busy';
}

export interface EntryChannelItem {
  id: string;
  icon: string;
  name: string;
  desc: string;
  badge: string;
  badgeTone: 'primary' | 'accent' | 'secondary';
}

export interface NewsItem {
  id: string;
  time: string;
  tag: string;
  tagTone: 'primary' | 'accent' | 'secondary';
  title: string;
  summary: string;
}

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  category: string;
  heat: string;
  image: string;
}

export interface StepItem {
  id: string;
  index: string;
  icon: string;
  title: string;
  desc: string;
}

export interface StatItem {
  id: string;
  value: string;
  label: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export interface FooterGroup {
  id: string;
  title: string;
  links: NavLinkItem[];
}

export const navLinks: NavLinkItem[] = [
  { label: '极速入口', href: '#entry' },
  { label: '快讯流', href: '#flash' },
  { label: '今日热榜', href: '#hot' },
  { label: '三步直达', href: '#how' },
  { label: '常见问题', href: '#faq' },
];

export const heroLines: HeroLineItem[] = [
  { id: 'line-main', name: '主线路 · 秒进直达', latency: '0.6s', status: '通畅', tone: 'good' },
  { id: 'line-a', name: '备用线路 A', latency: '1.1s', status: '通畅', tone: 'good' },
  { id: 'line-b', name: '备用线路 B', latency: '1.8s', status: '略挤', tone: 'busy' },
  { id: 'line-mobile', name: '移动端通道', latency: '0.9s', status: '通畅', tone: 'good' },
];

export const entryChannels: EntryChannelItem[] = [
  {
    id: 'entry-main',
    icon: 'ri-flashlight-line',
    name: '主线路直达',
    desc: '默认最优线路，点开即跳转，延迟常年最低',
    badge: '推荐',
    badgeTone: 'primary',
  },
  {
    id: 'entry-backup',
    icon: 'ri-git-branch-line',
    name: '备用线路',
    desc: '主线路拥挤时自动切换，稳不掉线',
    badge: '稳定',
    badgeTone: 'secondary',
  },
  {
    id: 'entry-mobile',
    icon: 'ri-smartphone-line',
    name: '移动端秒进',
    desc: '手机浏览器一键进入，省流量不卡顿',
    badge: '全终端',
    badgeTone: 'accent',
  },
  {
    id: 'entry-mirror',
    icon: 'ri-speed-up-line',
    name: '极速镜像',
    desc: 'CDN 多节点加速，开页比主线路还快一步',
    badge: '加速',
    badgeTone: 'accent',
  },
  {
    id: 'entry-archive',
    icon: 'ri-history-line',
    name: '往期合集',
    desc: '过去的入口与合集归档，一页翻完不遗漏',
    badge: '归档',
    badgeTone: 'secondary',
  },
  {
    id: 'entry-hot',
    icon: 'ri-fire-line',
    name: '热点聚合',
    desc: '按时间汇总当下最热，点开直接开吃',
    badge: '热',
    badgeTone: 'primary',
  },
];

export const newsFlash: NewsItem[] = [
  {
    id: 'flash-1',
    time: '09:42',
    tag: '线路',
    tagTone: 'accent',
    title: '主线路延迟再降，秒进更稳',
    summary: '主线路节点完成一次扩容，跳转平均耗时降到 0.6s，高峰期也更从容。',
  },
  {
    id: 'flash-2',
    time: '09:15',
    tag: '热榜',
    tagTone: 'primary',
    title: '今日热榜已更新',
    summary: '榜单按访问热度重新排序，前三位变化较大，可直接从热榜一键进入。',
  },
  {
    id: 'flash-3',
    time: '08:50',
    tag: '入口',
    tagTone: 'secondary',
    title: '新增一条备用镜像',
    summary: '备用镜像已上线，主线路拥堵时会自动引导，不需要手动来回切换。',
  },
  {
    id: 'flash-4',
    time: '08:20',
    tag: '提示',
    tagTone: 'accent',
    title: '早高峰访问提示',
    summary: '8:00 至 10:00 为访问高峰，若遇缓慢建议优先走极速镜像入口。',
  },
  {
    id: 'flash-5',
    time: '07:55',
    tag: '移动端',
    tagTone: 'secondary',
    title: '移动端秒进通道优化',
    summary: '移动端首屏加载进一步压缩，弱网环境下也能更快进入。',
  },
  {
    id: 'flash-6',
    time: '07:30',
    tag: '归档',
    tagTone: 'secondary',
    title: '昨日入口与合集已归档',
    summary: '昨日用过的入口与合集已整理完毕，可在往期合集里一键回看。',
  },
];

export const hotRanking: RankItem[] = [
  {
    id: 'hot-1',
    rank: 1,
    title: '影视圈换角风波后续整理',
    category: '影视',
    heat: '98.6万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20soft%20crimson%20geometric%20shapes%20and%20gentle%20amber%20accents%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-01&orientation=squarish',
  },
  {
    id: 'hot-2',
    rank: 2,
    title: '综艺路透合集持续发酵',
    category: '综艺',
    heat: '86.2万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20overlapping%20amber%20circles%20and%20cream%20tones%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-02&orientation=squarish',
  },
  {
    id: 'hot-3',
    rank: 3,
    title: '直播间言论争议时间线',
    category: '网红',
    heat: '74.9万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20diagonal%20crimson%20bars%20and%20soft%20orange%20glow%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-03&orientation=squarish',
  },
  {
    id: 'hot-4',
    rank: 4,
    title: '合作曲目版权分歧梳理',
    category: '音乐',
    heat: '61.3万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20rounded%20taupe%20arches%20and%20pale%20amber%20highlights%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-04&orientation=squarish',
  },
  {
    id: 'hot-5',
    rank: 5,
    title: '转会传闻多方回应汇总',
    category: '体育',
    heat: '52.7万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20soft%20amber%20wave%20lines%20and%20crimson%20dots%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-05&orientation=squarish',
  },
  {
    id: 'hot-6',
    rank: 6,
    title: '品牌解约事件全流程复盘',
    category: '商业',
    heat: '43.1万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20thumbnail%20on%20warm%20beige%20paper%20background%20with%20stacked%20crimson%20rounded%20squares%20and%20warm%20sand%20tones%2C%20minimal%20flat%20composition%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20clean%20studio%20lighting%2C%20muted%20warm%20tones%2C%20harmonious%20minimal%20aesthetic&width=320&height=320&seq=hl-rank-06&orientation=squarish',
  },
];

export const howItWorks: StepItem[] = [
  {
    id: 'step-1',
    index: '01',
    icon: 'ri-focus-3-line',
    title: '认准入口',
    desc: '打开本页，从六条线路里挑一条当前最顺的直接用。',
  },
  {
    id: 'step-2',
    index: '02',
    icon: 'ri-cursor-line',
    title: '一键进入',
    desc: '点击秒进按钮即可，不需要再搜索，也不用等跳转提示。',
  },
  {
    id: 'step-3',
    index: '03',
    icon: 'ri-rocket-2-line',
    title: '直达开吃',
    desc: '自动跳转到目标页面，省下的时间刚好用来安心吃瓜。',
  },
];

export const stats: StatItem[] = [
  { id: 'stat-1', value: '0.6s', label: '平均跳转耗时' },
  { id: 'stat-2', value: '99.9%', label: '线路可用率' },
  { id: 'stat-3', value: '12.6万', label: '今日进入次数' },
  { id: 'stat-4', value: '6 条', label: '常在线路' },
];

export const faqs: FaqItem[] = [
  {
    id: 'faq-1',
    q: '黑料入口到底是什么？',
    a: '它是一个入口导航页，把黑料入口跳转与秒进直达链接集中在一处，省去你到处搜索的时间。',
  },
  {
    id: 'faq-2',
    q: '为什么点开后会直接跳转？',
    a: '为了「要的就是快」，入口默认使用秒进模式，点击后自动跳转，中间不需要额外等待。',
  },
  {
    id: 'faq-3',
    q: '主线路打不开怎么办？',
    a: '直接切换到备用线路或极速镜像即可，页面会优先推荐当前最通畅的一条。',
  },
  {
    id: 'faq-4',
    q: '手机上能用吗？',
    a: '可以，移动端秒进通道针对手机浏览器做了优化，一键进入快速访问同样适用。',
  },
  {
    id: 'faq-5',
    q: '需要注册或付费吗？',
    a: '不需要，全程免注册、免登录，点开就能用，也不会收集任何账号信息。',
  },
  {
    id: 'faq-6',
    q: '入口地址以后会变吗？',
    a: '入口会持续维护，一旦变更会第一时间在快讯流里同步，建议先收藏本页。',
  },
];

export const footerGroups: FooterGroup[] = [
  {
    id: 'foot-1',
    title: '快捷入口',
    links: [
      { label: '极速入口通道', href: '#entry' },
      { label: '今日热榜', href: '#hot' },
      { label: '快讯流', href: '#flash' },
    ],
  },
  {
    id: 'foot-2',
    title: '使用帮助',
    links: [
      { label: '三步直达', href: '#how' },
      { label: '线路状态', href: '#top' },
      { label: '常见问题', href: '#faq' },
    ],
  },
];